// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// asset del logo
import logoSanLorenzo from '../../assets/images/san-lorenzo.svg';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain() {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <img src={logoSanLorenzo} alt="San Lorenzo Vini" width="40" />
      <Typography variant="h5" color="text.primary" sx={{ fontWeight: 'bold' }}>
        San Lorenzo Vini
      </Typography>
    </Box>
  );
}
